<template>


    <div class="container container-tabs">

        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane :name="String(item.val)" v-for="(item, index) in status_select" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>


            <el-button type="primary" icon="el-icon-search" @click="searchModelLists">搜索</el-button>
            <el-button @click="addModel_isShow=!addModel_isShow">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>


        </el-tabs>





        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
                  @selection-change="handleSelectionChange">



            <el-table-column prop="name" label="名称">
            </el-table-column>





            <el-table-column label="管理状态">
                <template slot-scope="scope">

                    <el-tag :type="scope.row.is_start.val==='0'?'info':'success'">
                        {{scope.row.is_start.alias}}
                    </el-tag>

                </template>
            </el-table-column>



            <el-table-column label="操作" width="150">
                <template slot-scope="scope">

                    <el-dropdown split-button type="primary"
                                 @click="editModel(scope.row.legwork_mode.legwork_mode_code)"
                                 trigger="click">

                        编辑模式

                        <el-dropdown-menu slot="dropdown">


                            <el-dropdown-item @click.native="delOrder(scope.row.legwork_mode.legwork_mode_code)">删除模式
                            </el-dropdown-item>

                        </el-dropdown-menu>

                    </el-dropdown>

                </template>
            </el-table-column>


        </el-table>



        <!-- 分页组件 -->
        <div class="pagination">

            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>

        </div>

        <!-- 添加模式组件 -->
        <addLegworkMode :isShow="addModel_isShow" @onSubmit="modelLists"></addLegworkMode>

        <!-- 添加模式组件 -->
        <editLegworkMode :data="drivingModel_dialog" :isShow="editModel_isShow"
                        @onSubmit="modelLists"></editLegworkMode>



    </div>


</template>

<script>
    var _this;
    import addLegworkMode from './addLegworkMode.vue';
    import editLegworkMode from './editLegworkMode.vue';
    // import cityMode from '../../common/cityMode.vue';
    // import iframeModel from '../../common/iframe.vue';
    import {
        config
    } from '../../../../utils/config.js'; //配置
    export default {
        components: {
            addLegworkMode,
            editLegworkMode,
            // cityMode,
            // iframeModel
        },
        data() {
            return {

                // 添加模式组件开关
                addModel_isShow: false,

                // 修改模式组件开关
                editModel_isShow: false,


                // 传入子组件的数据
                drivingModel_dialog: '',


                city_code: '',


                // 选项卡默认选中项
                activeName: 'all',

                mode_price: '',


                status_select: [],

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    is_start: ''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                },
            };
        },
        created() {
            _this = this;
            _this.modelLists();



            _this.value_city_code = JSON.parse(localStorage.getItem('login')).city.name;

            console.log(_this.value_city_code);


            _this.cityChange(JSON.parse(localStorage.getItem('login')).city.city_code)




            // 接收路由传参
            _this.search_data.city_code = _this.$route.query.city_code;

            if (_this.search_data.city_code != undefined) {
                _this.$post(
                    "/city/getCityDetails", {
                        city_code: _this.search_data.city_code
                    }
                ).then(res => {

                    _this.value_city_code = res.data.name;
                    _this.company_name = res.data.company.name;


                }).catch((err) => {

                })
            }
            _this.iframe_url = config.h5;
        },

        methods: {
            searchModelLists() {

                _this.search_data.page = 1;
                _this.modelLists();

            },


            toDetil(code) {

                _this.iframe_show = true;
                _this.iframe_param = code;

            },

            // 选项卡选中事件
            handleClick(tab, event) {
                // 点击的选项卡所对应的val值
                console.log(tab.name);
                if (tab.name != 'all') {
                    _this.search_data.is_start = tab.name;
                } else {
                    _this.search_data.is_start = '';
                }

                _this.modelLists();

            },

            editModel(code, city, status) {

                _this.editModel_isShow = !_this.editModel_isShow;
                _this.drivingModel_dialog = code;

            },



            // 获取模式
            modelLists() {

                _this.$post(
                    "/legwork/orderLegWorkModeLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {

                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                        // 状态下拉的数据
                        _this.status_select = _this.tableData[0].is_start.select_array;

                    }).catch((err) => {

                })

            },

            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;

                //初始化列表
                _this.modelLists();

            },

            handleSelectionChange(val) {

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].order_mode_code);

                }
                _this.delModelSubmit_data.order_mode_code = datalist;
            },


            cityChange(val) {

                _this.search_data.city_code = val;
                if (val != '') {

                    _this.$post(
                        "/city/getCityDetails", {
                            city_code: val
                        }
                    ).then(res => {

                        _this.company_name = res.data.company.name;
                        _this.city_code = res.data.city.city_code;

                    }).catch((err) => {

                    })

                } else {
                    _this.company_name = '';
                }

            },

            //搜索的下拉框弹出触发
            cityVisibleChange(val) {

                if (val && _this.options_city_code.length < 1) {
                    // 请求公司管理接口获取公司唯一编码
                    _this.$post(
                        "/city/cityLists",
                        _this.city_options_data
                    ).then(res => {
                        _this.options_city_code = res.data

                    }).catch((err) => {

                    })
                }

            },


            //删除功能
            delOrder(code) {


                _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning',

                }).then(() => {

                    _this.$post(
                        "/legwork/delOrderLegWorkModeSubmit", {
                            legwork_mode_code: code,
                            city_code:JSON.parse(localStorage.getItem('login')).city.city_code
                        }
                    ).then(res => {

                        _this.modelLists();
                        _this.$message.success('删除成功');

                    }).catch((err) => {

                    })

                }).catch(() => {

                    _this.$message.info('已取消删除');

                });


            },
            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown+.el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    .content-body {
        display: flex;
        flex-wrap: wrap;
    }

    .content-body .el-form-item {
        width: 30%;

    }
</style>